import './menuMain.scss';
import $ from 'jquery';

$(function() {
    $("#main-menu").accessibleDropDown();
});

$.fn.accessibleDropDown = function () {
    // Ajout des rôles Aria : Menubar et Menuitem
    //$(this).attr('role', 'Menu').find('li').attr('role', 'Menuitem');



    var menu_item_having_submenu = $(this).find('> li.menu-item-has-children');

    // Ajout de l'attribut aria-haspopup pour les éléments de menu ayant des sous-menu
    $(menu_item_having_submenu).attr('aria-haspopup', 'true');

    // Ajout du rôle menu pour les sous-menu
    $(menu_item_having_submenu).children('ul').attr({'aria-label': 'Submenu' });

    // Sur hover ouvrir le sous-menu en accordéon
    $(menu_item_having_submenu).hover(function(e){
        e.preventDefault();
        $(this).children('ul').stop().slideDown();
        $(this).addClass('active');
        $(this).parent().addClass('active');

        return;
    }, function(e){
        e.preventDefault();
        $(this).children('ul').stop().slideUp();
        $(this).removeClass('active');
        $(this).parent().removeClass('active');
        return;
    });

    // Accessibilité clavier
    $(this).keydown(function(e){
        // SI LA TOUCHE APPUYÉE N'EST PAS UNE FLÈCHE ON SORT DE LA FONCTION
        if ([13,37,38,39,40].indexOf(e.keyCode) == -1) { return; }
        switch(e.keyCode) {
            case 37: // FLÈCHE DE GAUCHE
                var dropdown =  $(":focus").parent().parent('.sub-menu'); // Regarde s'il y a un sous-menu sous l'item en focus
                dropdown.prev().removeClass('active');
                if(dropdown.length > 0){
                    e.preventDefault();
                    e.stopPropagation();
                    dropdown.hide();
                    dropdown.prev("a").focus();
                }
                break;
            case 38: // FLÈCHE DU HAUT
                e.preventDefault();
                e.stopPropagation();
                // SI C'EST LE PREMIER ITEM DU MENU ON RETOURNE AU DERNIER ITEM DU MENU
                if($(":focus").parent("li").prevAll('li').filter(':visible').length == 0) {
                    $(":focus").parent("li").nextAll("li").last().find("a").focus();
                } else {
                    $(":focus").parent("li").prevAll('li').filter(':visible').first().find("a").focus();
                }
                break;
            case 39: // FLÈCHE DE DROITE
                var dropdown =  $(":focus").next('.sub-menu');
                if(dropdown.length > 0 && dropdown.not(":visible")){
                    dropdown.prev().addClass('active');
                    // Make sure to stop event bubbling
                    e.preventDefault();
                    e.stopPropagation();
                    dropdown.show();
                    dropdown.find('a').filter(':visible').first().focus();
                }
                break;
            case 13: // ENTER
                var dropdown =  $(":focus").next('.sub-menu');
                if(dropdown.length > 0 && dropdown.not(":visible")){
                    dropdown.prev().addClass('active');
                    // Make sure to stop event bubbling
                    e.preventDefault();
                    e.stopPropagation();
                    dropdown.show();
                    dropdown.find('a').filter(':visible').first().focus();
                }
                break;
            case 40: // FLÈCHE DU BAS
                e.preventDefault();
                e.stopPropagation();
                // SI ON EST AU DERNIER ITEM DE LA LISTE, ON REVIENT AU PREMIER
                if($(":focus").parent("li").nextAll('li').filter(':visible').length == 0) {
                    $(":focus").parent("li").prevAll("li").last().find("a").focus();
                } else {
                    $(":focus").parent("li").nextAll('li').filter(':visible').first().find("a").focus();
                }
                break;
        }
    });
}